import { useEffect, useState } from "react";
import styles from '../../../../styles/incidents.module.css';
import { useFieldArray, useForm } from "react-hook-form";
import { Button, Col, Row } from "react-bootstrap";
import { yupResolver } from '@hookform/resolvers/yup';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply, faPlus } from "@fortawesome/free-solid-svg-icons";
import ButtonOverride from "../../../../components/buttonoverride";
import FormInputValidationMessage from '../../../../components/forminputvalidationmessage';
import { buildIncidentEmergencyBackupValidationSchema } from './incident-validation';

const _hasFollowup = (id,backupTypes = []) => {
    const selectedObject = backupTypes.find(option => option.id === id);
    
    return selectedObject ? selectedObject.hasfollowup : null
}

const IncidentBackupWidget = ({control,definitions}) => {
    const [addMode,setAddMode] = useState(false);

    const {fields,append,remove,update} = useFieldArray({
        control,
        name: 'emergencyBackupAssistance',
        keyName: 'rhfid'
    });

    const Adder = ({backupTypes = [],toggleMode}) => {

        const initialValues = {
            id: null,
            emergencyAssistanceType: '',
            emergencyAssistanceTypeOther: '',
            isResolved: false
        }

        const validationSchema = buildIncidentEmergencyBackupValidationSchema(backupTypes);

        const {handleSubmit,register,watch,setValue,trigger,formState: {errors}} = useForm({defaultValues: initialValues,resolver: yupResolver(validationSchema)});

        const _onSubmit = (data) => {
            const appendData = {
                ...data,
                id: crypto.randomUUID()
            }
            append(appendData);

            toggleMode();
        }

        const selectFieldValue = watch('emergencyAssistanceType');
        const txtOtherValue = watch('emergencyAssistanceTypeOther');

        useEffect(() => {
            // Trigger validation when selectField changes
    
            if(!_hasFollowup(selectFieldValue,backupTypes)){
                setValue('emergencyAssistanceTypeOther','');
            }
    
            trigger('emergencyAssistanceTypeOther');
        }, [selectFieldValue, trigger,backupTypes,setValue]);
    
        useEffect(() => {
    
            trigger('emergencyAssistanceTypeOther');
        }, [txtOtherValue, trigger]);

        return(
            <>
                <div className={styles.notificationsHeader}>
                    <h5 className='fw-bold me-1 mb-0'>
                        Add Emergency Backup
                    </h5>
                </div>
                <div className={styles.notificationsBody}>
                    <Row className='ms-0 me-0'>
                        <Col xs={12}>
                            <div className={styles.inputCol}>
                                <label htmlFor='emergencyAssistanceType'>Backup Type</label>
                                <select id='emergencyAssistanceType' style={{width: '100%',height: '30px'}} {...register("emergencyAssistanceType")}>
                                    <option value='' disabled>--Please Make a selection--</option>
                                    {
                                        backupTypes.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <FormInputValidationMessage error={errors.emergencyAssistanceType} />
                        </Col>
                        <Col xs={12}>
                            <label htmlFor='emergencyAssistanceTypeOther'>Other</label>
                            <input id='emergencyAssistanceTypeOther' autoComplete='off' type='text' style={{width: '100%',height: '30px'}} {...register("emergencyAssistanceTypeOther")} disabled={!_hasFollowup(selectFieldValue,backupTypes)}/>
                            <FormInputValidationMessage error={errors.emergencyAssistanceTypeOther} />
                        </Col>
                        <Col xs={12}>
                            <div className="mt-2">
                                <strong>Resolved?</strong>
                            </div>
                            <label className="me-2">
                                <input type="checkbox" {...register('isResolved')}/>
                                Yes
                            </label>
                        </Col>
                    </Row>
                </div>
                <div className={styles.notificationsFooter}>
                    <Button type="button" variant="danger" onClick={toggleMode}>Cancel</Button>
                    <Button type="button" variant="primary" onClick={handleSubmit(_onSubmit)}>Insert</Button>
                </div>
            </>
        )
    }

    const List = ({fields = [],toggleMode,backupTypes = []}) => {

        const _getType = (item) => {
            const type = item.emergencyAssistanceTypeOther
            ?   item.emergencyAssistanceTypeOther
            :   backupTypes.find((emback) => emback.id === item.emergencyAssistanceType)?.name || "N/A"

            return type;
        }

        const _updateItem = (index) => {
            update(index, { ...fields[index], isResolved: !fields[index].isResolved });
        };

        return(
            <>
                <div className={styles.notificationsHeader}>
                    <h5 className='fw-bold me-1 mb-0'>
                        Emergency Backups
                    </h5>
                    {
                        fields.length > 0
                        &&
                        <Button type='button' variant='success' size='sm' className={styles.addNotificationButton} aria-label='Add Notification' onClick={toggleMode}>
                                <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    }
                </div>
                <div className={`${styles.notificationsBody} ${fields.length === 0 ? styles.start : null}`}>
                {
                    fields.length > 0
                    ?
                        <ul className={styles.notificationList}>
                        {
                            fields.map((item,index) => {
                                const type = _getType(item);
                                return(
                                    <li key={index} className={styles.notificationItem}>
                                        <div className={styles.notificationContent}>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <strong>{type}</strong>
                                                <Button type="button" size="sm" variant={`${item.isResolved? 'success' : 'danger'}`} onClick={() => _updateItem(index)}>
                                                    {
                                                        item.isResolved
                                                        ?
                                                            <>Resolved</>
                                                        :
                                                            <>Not Resolved</>
                                                    }
                                                </Button>
                                            </div>
                                        </div>
                                        <ButtonOverride type="button" className={styles.deleteAddedButton} aria-label="Remove Notification" title="Remove Notification" onClick={() => remove(index)} >
                                            <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                        </ButtonOverride>
                                    </li>
                                )
                            })
                        }
                        </ul>
                    :
                        <Button type='button' variant='success' className={styles.addNotificationButtonLg} aria-label='Add Notification' onClick={toggleMode}>
                            <FontAwesomeIcon icon={faPlus} size='2xl'/>
                        </Button>
                }
                </div>
            </>
        )
    }

    return(
        <div className={styles.notificationsContainer}>
            {
                addMode
                ?
                    <Adder backupTypes={definitions.emergencyassistance} toggleMode={() => setAddMode(false)}/>
                :
                    <List fields={fields} toggleMode={() => setAddMode(true)} backupTypes={definitions.emergencyassistance}/>
            }
        </div>
    )
}

export default IncidentBackupWidget;
